import {
    BrowserRouter, HashRouter, Route, Routes,
} from 'react-router-dom';
import { useEffect, useState } from 'react';
import { MenuContextWrapper } from '../context/menu';
import AuthPage from '../pages/auth/auth';
import RegisterPage from '../pages/auth/register';
import LayoutPage from '../pages/layout';
import PageContainer from '../containers/page';
import { UserContextWrapper } from '../context/user';
import AvitoAuthPage from '../pages/avito/auth';
import AiAgentsListPage from '../pages/ai-agents/list';
import AiAgentsPromptsPage from '../pages/ai-agents/prompts';
import AiAgentsKnowledgePage from '../pages/ai-agents/knowledge';
import AiAgentChatPage from '../pages/ai-agents/chat';

export interface IBrowserRouteProps {
    hideHashRouter: (hide: boolean) => void;
}

const MainPage = ({ hideHashRouter }: IBrowserRouteProps) => {
    useEffect(() => {
        hideHashRouter(false);
    }, []);
    return null;
};

export default function AppRouter() {
    const [hideHashRouter, setHideHashRouter] = useState(true);

    return (
        <MenuContextWrapper>
            <UserContextWrapper>
                {!hideHashRouter && (
                    <HashRouter>
                        <Routes>
                            {/* Страницы содержащие макет */}
                            <Route path="/" element={<PageContainer />}>
                                <Route path="/:objectName" element={<LayoutPage />} />
                                <Route path="/:objectName/:pageType" element={<LayoutPage />} />
                                <Route path="/:objectName/:pageType/:objectId" element={<LayoutPage />} />
                            </Route>
                            {/* Авторизация */}
                            <Route path="/auth" element={<AuthPage />} />
                            <Route path="/register" element={<RegisterPage />} />
                            {/* Интеграция ИИ */}
                            <Route element={<PageContainer menuInitIgnore />}>
                                <Route path="/ai-agents/list" element={<AiAgentsListPage />} />
                                <Route path="/ai-prompts/list" element={<AiAgentsPromptsPage />} />
                                <Route path="/ai-knowledge/list" element={<AiAgentsKnowledgePage />} />
                                <Route path="/ai-agents/:id/chat" element={<AiAgentChatPage />} />
                            </Route>
                        </Routes>
                    </HashRouter>
                )}
                <BrowserRouter>
                    <Routes>
                        <Route
                            path="/"
                            element={<MainPage hideHashRouter={setHideHashRouter} />}
                        />
                        <Route
                            path="/avito/auth"
                            element={<AvitoAuthPage hideHashRouter={setHideHashRouter} />}
                        />
                    </Routes>
                </BrowserRouter>
            </UserContextWrapper>
        </MenuContextWrapper>
    );
}
